export default __webpack_public_path__ + "static/media/shard-culture.da064039.glb";